import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <>
      <footer className="site-footer">
        <div className="container">
          <div className="row">
            {/* {Abouts && Abouts.length >= 0
              ? Abouts.map((item, idx) => (
                  <div className="col-sm-12 col-md-6" key={idx}>
                    <h6>{item.head}</h6>
                    <p className="text-justify">{item.desc}</p>
                  </div>
                ))
              : null} */}
            <div className="col-xs-6 col-md-6">
              <h6>الموقع</h6>
              <div className="map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3434.479191869751!2d32.276523595854!3d30.5922444129511!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f859678c9bd935%3A0xe966ea38d4c89207!2z2LPZitmG2YXYpyDYr9mG2YrYpw!5e0!3m2!1sar!2seg!4v1704836623310!5m2!1sar!2seg"
                  width="100%"
                  height="100%"
                  title="Google Map"
                  frameBorder="0"
                  allowFullScreen=""
                  aria-hidden="false"
                  tabIndex="0"
                />
              </div>
            </div>
            <div className="col-xs-6 col-md-3">
              <h6>الخدمات</h6>
              <ul className="footer-links">
                <li>
                  <Link to="/user/services/car">
                    <i className="fas fa-chevron-left"></i> خدمات السيارات
                  </Link>
                </li>
                <li>
                  <Link to="/user/trafficserv">
                    <i className="fas fa-chevron-left"></i> خدمات المرور
                  </Link>
                </li>
                <li>
                  <Link to="/user/touristserv">
                    <i className="fas fa-chevron-left"></i>خدمات السياحة
                  </Link>
                </li>
                <li>
                  <Link to="/user/localserv">
                    <i className="fas fa-chevron-left"></i> خدمات المحليات
                  </Link>
                </li>
                <li>
                  <Link to="/user/realstatementserv">
                    <i className="fas fa-chevron-left"></i> خدمات الشهر العقاري
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-md-3">
              <ul className="social-icons">
                <li>
                  <a className="facebook" href={"https://www.facebook.com/profile.php?id=61555376251919&mibextid=ZbWKwL"}>
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a className="twitter" href="#i">
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a className="dribbble" href="#i">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </li>
                <li>
                  <a className="linkedin" href="#k">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <hr />
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-6 col-xs-12">
              <p className="copyright-text">
                جميع حقوق النشر محفوظة 2023 &copy; لشركة
                <a href="https://www.facebook.com/profile.php?id=61552524247309&mibextid=LQQJ4d">
                  {" "}
                  Deal {" "}
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
